import React from 'react';
import LiquidGlassCard from '../../components/LiquidGlassCard/LiquidGlassCard';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <div className="container">
        <div className="contact-header">
          <h1 className="page-title">Contact Us</h1>
          <p className="page-subtitle">
            Have questions or need help? Reach out to us through any of the channels below.
          </p>
        </div>

        <div className="contact-grid">
          <LiquidGlassCard className="contact-card">
            <div className="contact-card-icon">
              <span className="material-symbols-outlined">language</span>
            </div>
            <h3 className="contact-card-title">Website</h3>
            <p className="contact-card-desc">Visit our main website for more information</p>
            <a
              href="https://kainovations.com"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card-link"
            >
              kainovations.com
              <span className="material-symbols-outlined">open_in_new</span>
            </a>
          </LiquidGlassCard>

          <LiquidGlassCard className="contact-card">
            <div className="contact-card-icon">
              <span className="material-symbols-outlined">mail</span>
            </div>
            <h3 className="contact-card-title">Email</h3>
            <p className="contact-card-desc">Send us an email and we'll get back to you</p>
            <a
              href="mailto:contactus.kainovations@gmail.com"
              className="contact-card-link"
            >
              contactus.kainovations@gmail.com
              <span className="material-symbols-outlined">arrow_forward</span>
            </a>
          </LiquidGlassCard>
        </div>
      </div>
    </div>
  );
};

export default Contact;
